var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWineOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9509 4.28862C11.3533 4.285 10.7756 4.50284 10.3292 4.90012C9.88282 5.2974 9.59944 5.84594 9.53372 6.43988C9.26783 9.00205 9.1228 12.8695 9.1228 13.9572C9.1228 20.2901 13.9571 23.6258 19.9999 23.6258C26.0428 23.6258 30.8771 20.2901 30.8771 13.9572C30.8771 12.8695 30.7321 9.12291 30.4662 6.43988C30.4004 5.84594 30.1171 5.2974 29.6707 4.90012C29.2242 4.50284 28.6465 4.285 28.049 4.28862H11.9509Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19238 11.54H30.8057",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.6257V35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1656 35.7114H24.8342",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWineOutline);
export default __webpack_public_path__ + "static/media/icon_wine_outline.d02e79b961ae78c045977e2bfc616589.svg";
export { ForwardRef as ReactComponent };